<template>
	<AppLayout
		:title="assembly.title"
		:subtitle="subtitle"
		:return-url="returnUrl ?? route('association.assemblies.index')"
		:return-label="returnLabel ?? trans('assemblies.title')"
	>
		<template #actions>
			<slot name="actions"/>
		</template>
		<slot/>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {defineProps, ref, type Ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import {type Assembly} from '@/Types/Association/Assemblies/Assembly'

const props = defineProps<{
	subtitle:string,
	assembly:Assembly,
	returnUrl?:string,
	returnLabel?:string,
}>()

const assembly:Ref<Assembly> = ref(props.assembly)
</script>